import { render, staticRenderFns } from "./AppDataStep.vue?vue&type=template&id=5355d508&scoped=true&"
import script from "./AppDataStep.vue?vue&type=script&lang=js&"
export * from "./AppDataStep.vue?vue&type=script&lang=js&"
import style0 from "./AppDataStep.vue?vue&type=style&index=0&id=5355d508&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5355d508",
  null
  
)

export default component.exports